const getPayload = (
  { identifier, levelId, contentId, timeStarted, userId, userUniqueId },
  additionalProperties,
) => {
  return JSON.stringify({
    ...additionalProperties,
    access_key: identifier,
    article: {
      id: levelId,
    },
    content: {
      id: contentId,
    },
    timeStamp: new Date().getTime() - timeStarted,
    user: {
      id: userId,
      unique_id: userUniqueId,
    },
    visibleScreenSize: {
      height: document.body.clientHeight,
      width: document.body.clientWidth,
    },
  });
};

export default getPayload;
